import { Star } from "lucide-react";
import { Field, SectionTitle, inputCls, labelCls } from "@/components/admin/fields";
import { iconFor } from "@/lib/icons";

const PackageRow = ({ pkg, onChange, onFeature }) => {
  const Icon = iconFor(pkg.icon);
  return (
    <div data-testid={`admin-package-${pkg.id}`} className="border border-white/10 bg-[#0A0A0A] p-5 md:p-6">
      <div className="mb-5 flex items-center justify-between">
        <span className="flex items-center gap-3 font-display text-sm tracking-[0.3em] text-zinc-500">
          <Icon size={18} className="text-[#E60000]" />
          {pkg.index}
        </span>
        <button
          type="button"
          onClick={onFeature}
          data-testid={`admin-package-feature-${pkg.id}`}
          className={`inline-flex items-center gap-1.5 border px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] transition-[border-color,color,background-color] duration-300 ${
            pkg.featured ? "border-[#E60000] bg-[#E60000] text-white" : "border-white/15 text-zinc-500 hover:border-white/40 hover:text-white"
          }`}
        >
          <Star size={11} strokeWidth={2.5} />
          {pkg.featured ? "Highlighted" : "Highlight"}
        </button>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-[1fr_120px]">
        <Field
          label="Package name"
          testId={`admin-package-name-${pkg.id}`}
          value={pkg.name}
          maxLength={60}
          onChange={(e) => onChange({ name: e.target.value })}
        />
        <Field
          label="Price"
          testId={`admin-package-price-${pkg.id}`}
          value={pkg.price}
          maxLength={12}
          placeholder="$60"
          onChange={(e) => onChange({ price: e.target.value })}
        />
      </div>
      <label className="mt-4 block">
        <span className={labelCls}>What's included — one per line</span>
        <textarea
          data-testid={`admin-package-includes-${pkg.id}`}
          rows={6}
          className={`${inputCls} resize-y leading-relaxed`}
          value={pkg.includes.join("\n")}
          onChange={(e) => onChange({ includes: e.target.value.split("\n") })}
        />
      </label>
    </div>
  );
};

export const PackageEditor = ({ packages, onChange }) => {
  const update = (i, patch) => onChange(packages.map((p, idx) => (idx === i ? { ...p, ...patch } : p)));
  const feature = (i) => onChange(packages.map((p, idx) => ({ ...p, featured: idx === i ? !p.featured : false })));
  return (
    <section>
      <SectionTitle hint="Prices show as “Starting at”. Use any format you like: $60, $60+, From $60.">
        Packages
      </SectionTitle>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {packages.map((pkg, i) => (
          <PackageRow key={pkg.id} pkg={pkg} onChange={(patch) => update(i, patch)} onFeature={() => feature(i)} />
        ))}
      </div>
    </section>
  );
};

export default PackageEditor;
